import { CircularProgress } from '@material-ui/core';
import * as React from 'react';

import styles from './Loader.module.styl';

interface IProps {
  fullSize?: boolean;
  sizeValue?: number;
  centrify?: boolean;
}

export const Loader = ({ fullSize, sizeValue, centrify = true }: IProps) =>
  fullSize ? (
    <div className={styles.fullSize}>
      <CircularProgress size={100} />
    </div>
  ) : (
    <div className={centrify ? styles.loader : styles.inbutton}>
      <CircularProgress size={sizeValue || 100} />
    </div>
  );
